var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categorie category-component"},[_c('h6',[_vm._v(_vm._s(_vm.categorie.name))]),_c('div',{staticClass:"edit-delete mt-2"},[_vm._t("edit-delete")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }